// ##### 25-02-05 Komarov
import { Select } from 'antd';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';
import { VehicleTypes } from '../../../../../StaticJsonData/VehicleTypes';

// ##### Komarov 2025-07-14
const TransfersComponent = ({ props }) => {
  // ##### Komarov 2025-08-05
  const chooseTypeOfVehicle = useSelector(state => state.pagesRedux[state.language]?.ChooseTypeOfVehicle || '');
  const { selectVehicleTypes, vehicleTypes, vehicleTypesInitialState } = props;
  // ##### 25-05-19 Komarov
  const SupplierForm_PleaseSelect = useSelector(state => state.pagesRedux[state.language]?.SupplierForm_PleaseSelect || '');
  const locale = useSelector(state => state.language);

  return (
    <div className="groupTravelblocks_2" key={uniqueId()}>
      <span>
        {/* ##### 23-09-07 Komarov */}
        {chooseTypeOfVehicle}
      </span>
      <Select
        onChange={selectVehicleTypes}
        bordered={true}
        style={{ minWidth: '5vw' }}
        key={uniqueId()}
        // ##### 24-03-21 Komarov
        value={
          (vehicleTypes === vehicleTypesInitialState &&
            SupplierForm_PleaseSelect) ||
          vehicleTypes
        }
      >
        <>
          {
            // ##### 24-03-21 Komarov
            VehicleTypes(locale)?.map(item => {
              return (
                <Option value={item} key={item}>
                  {item}
                </Option>
              );
            })
          }
        </>
      </Select>
    </div>
  );
};

// ##### 25-05-21 Komarov
export default TransfersComponent;
